// extracted by mini-css-extract-plugin
export default {"childCell":"defaultTable_childCell__29umI"};